import { Point as FabricPoint } from 'fabric';

function getDistance(p1: FabricPoint, p2: FabricPoint) {
  return Math.sqrt((p1.x - p2.x) ** 2 + (p1.y - p2.y) ** 2);
}

export default getDistance;
